import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    GetReportData,
    getOperationEntitiesByGroupForDropDown
};

async function GetReportData(data) {
    var model = {
        groupID: parseInt(data.groupID),
        factoryID: parseInt(data.factoryID),
        date: data.date
    };
    const response = await CommonPost('/api/InterEstateLeafReport/GetInterEstateLeafReportData', null, model);
    return response.data;

}

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllFactoryFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}